

















































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Arrows from '@/components/Arrows.vue'
import PhoneInput from '@/components/inputs/PhoneInput.vue'
import SsnInput from '@/components/inputs/SsnInput.vue'
import {
  exists,
  emailRules,
  postalCodeRules,
  passwordRules,
  passwordMatches,
} from '@/util/inputValidation'

@Component({
  components: {
    Arrows,
    PhoneInput,
    SsnInput,
  }
})
export default class ContractorForm extends Vue {

  @Prop({ default: false }) retry!: boolean
  
  form: any = {}
  showPassword = false
  states = ['AL','AK','AS','AZ','AR','CA','CO','CT','DE','DC','FM','FL','GA','GU','HI','ID','IL','IN','IA','KS','KY','LA','ME','MH','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','MP','OH','OK','OR','PW','PA','PR','RI','SC','SD','TN','TX','UT','VT','VI','VA','WA','WV','WI','WY']

  mounted() {
    if (this.$route.query.manager_reference) {
      this.form.manager_reference = this.$route.query.manager_reference
    }
  }

  get rules() {
    return {
      firstName: [exists('First name required')],
      lastName: [exists('Last name required')],
      phone: [exists('Phone number required')],
      email: emailRules,
      managerReference: [exists('Manager reference number required')],
      address1: [exists('Address 1 required')],
      city: [exists('City required')],
      state: [exists('State required')],
      postalCode: postalCodeRules,
      dateOfBirth: [exists('Date of birth required')],
      password: passwordRules,
      confirmPassword: [exists('Password confirmation required')],
      passwordMatches,
    }
  }

  @Watch('form')
  onFormChange() {
    this.$emit('update', this.form)
  }
}
